<template>
    <section>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(saveExtendPhaseTerm)">
                <div class="modal-card" style="width: 1080px">
                    <header class="modal-card-head">
                        <p v-if="update" class="modal-card-title">Editar Ampliación de Plazo de Declaración de una Unidad</p>
                        <p v-if="create" class="modal-card-title">Ampliar Plazo de Declaración de una Unidad</p>
                        <button type="button" class="delete" @click="$emit('close')" />
                    </header>
                    <section class="modal-card-body">

                        <div class="columns">
                            <div class="column">
                                <b-field label="Unidad *">
                                    <ValidationProvider name="Unidad" rules="required" v-slot="{ errors }">
                                        <multiselect v-model="extendPhaseTerm.id_object"
                                            :options="units.map(unit => unit.id)"
                                            :custom-label="opt => units.find(x => x.id === opt).name"
                                            placeholder="Seleccione una Unidad" selectLabel="Presione para seleccionar"
                                            selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                            :allow-empty="false" :disabled="update">
                                            <template v-slot:noOptions>
                                                No existen datos
                                            </template>
                                            <span slot="noResult">
                                                No se encontraron elementos.
                                            </span>
                                        </multiselect>
                                        <span class="validation-alert">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </b-field>
                            </div>
                        </div>

                        <div class="columns mb-6">
                            <div class="column">
                                    <b-field label="Fecha de Inicio *">
                                        <ValidationProvider name="Fecha de Inicio"
                                            :rules="{ start_date_before_end_date: extendPhaseTerm.end_date, required: true }"
                                            v-slot="{ errors }">
                                            <b-datepicker v-model="extendPhaseTerm.start_date" icon="calendar-alt" trap-focus
                                                locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                            </div>

                            <div class="column">
                                
                                <b-field label="Fecha de Término *">
                                    <ValidationProvider name="Fecha de Término"
                                        :rules="{ end_date_not_before_start_date: extendPhaseTerm.start_date, required: true }"
                                        v-slot="{ errors }">
                                        <b-datepicker v-model="extendPhaseTerm.end_date" icon="calendar-alt" trap-focus
                                            locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </b-field>
                            </div>
                        </div>
                        
                        <br>
                        <br>

                        <b-loading is-full-page v-model="isLoading" />
                    </section>
                </div>
                <footer class="modal-card-foot is-flex is-justify-content-space-between">
                    <b-button label="Cerrar" @click="$emit('close')" />
                    <b-button v-if="create" label="Ampliar Plazo de Declaración" type="is-purple-color-usach"
                        icon-left="users-cog" @click="confirmSaveExtendPhaseTerm()" />
                    <b-button v-if="update" label="Editar Ampliación de Plazo de Declaración" type="is-warning" icon-left="edit"
                        @click="confirmEditExtendPhaseTerm()" />
                </footer>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ModalNewEditExtendPhaseTerm',

    props: {
        create: {
            type: Boolean,
            default: false
        },
        update: {
            type: Boolean,
            default: false
        },
        extendPhaseTerm: {
            type: Object,
            default: () => ({
                is_unit: true,
                id_object: null,
                start_date: null,
                end_date: null,
                performance_phase_id: null,
            })
        },
        performancePhaseId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            isLoading: false,

            //Datos a Traer
            units: [],
        }
    },

    async created() {
        if (this.update) {
            this.extendPhaseTerm.start_date = new Date(this.extendPhaseTerm.start_date)
            this.extendPhaseTerm.end_date = new Date(this.extendPhaseTerm.end_date)
        }
        await this.getUnits();
    },

    methods: {
        async getUnits() {
            this.isLoading = true;
            await axios
                .get('/units/get-departments-of-engineering-faculty.json')
                .then(response => {
                    this.units = response.data;
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer los Plazos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        async confirmSaveExtendPhaseTerm() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.$buefy.dialog.confirm({
                title: 'Agregar Ampliación',
                message: `¿Está seguro de agregar la Ampliación de Plazo de Declaración de la Unidad.`,
                confirmText: 'Sí',
                type: 'is-warning',
                hasIcon: true,
                icon: 'exclamation-triangle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: async () => {
                    await this.saveExtendPhaseTerm();
                }
            })
        },

        async confirmEditExtendPhaseTerm() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.$buefy.dialog.confirm({
                title: 'Editar Ampliación',
                message: `¿Está seguro de editar la Ampliación de Plazo de Declaración de la Unidad.`,
                confirmText: 'Sí',
                type: 'is-warning',
                hasIcon: true,
                icon: 'exclamation-triangle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: async () => {
                    await this.editExtendPhaseTerm();
                }
            })
        },

        async saveExtendPhaseTerm() {
            this.isLoading = true;
            this.extendPhaseTerm.is_unit = true;
            this.extendPhaseTerm.performance_phase_id = this.performancePhaseId;
            await axios
                .post('/extend_phase_terms.json', this.extendPhaseTerm)
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: `Se amplió el Plazo de Declaración de la Unidad seleccionada.`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                    this.$emit('close');
                })
                .catch(error => {
                    let msg = error.response.data.errors ? error.response.data.errors : 'Hubo un error al ampliar el Plazo de Declaración. Intente más tarde';
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: msg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        async editExtendPhaseTerm() {
            this.isLoading = true;
            this.extendPhaseTerm.is_unit = true;
            await axios
                .put(`/extend_phase_terms/${this.extendPhaseTerm.id}.json`, this.extendPhaseTerm)
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: `Se editó la Ampliación de Plazo de Declaración de la Unidad seleccionada.`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                    this.$emit('close');
                })
                .catch(error => {
                    let msg = error.response.data.errors ? error.response.data.errors : 'Hubo un error al editar la Ampliación de Plazo de Declaración. Intente más tarde';
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: msg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

    }

}
</script>